module.exports = __webpack_public_path__ + "static/media/image_19.684a213b.png";